/**
 * Em'z Blendz — Mobile Nav Drawer Focus Trap
 * Version: 1.0
 *
 * Watches for the drawer--is-open class on #NavDrawer and:
 *   1. Traps Tab / Shift+Tab inside the drawer
 *   2. Sets `inert` on main content + footer so screen readers skip them
 *   3. Focuses the close button when drawer opens
 *   4. Returns focus to the hamburger button when drawer closes
 *
 * Uses MutationObserver on class changes — zero overhead when drawer is closed.
 * Gracefully degrades: if any element is missing, it just skips that step.
 */
(function() {
  'use strict';

  var drawer = document.getElementById('NavDrawer');
  if (!drawer) return;

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var menuButton = document.querySelector('.js-drawer-open-nav');
  var isTrapping = false;

  /**
   * Get all visible focusable elements inside the drawer.
   */
  function getFocusableElements() {
    return Array.prototype.filter.call(
      drawer.querySelectorAll(FOCUSABLE),
      function(el) { return el.offsetParent !== null; }
    );
  }

  /**
   * Keydown handler: wrap focus at drawer boundaries, close on Escape.
   */
  function onKeyDown(e) {
    if (e.key === 'Escape') {
      var closeBtn = drawer.querySelector('.js-drawer-close');
      if (closeBtn) closeBtn.click();
      return;
    }

    if (e.key !== 'Tab') return;

    var focusable = getFocusableElements();
    if (focusable.length === 0) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  /**
   * Mark content outside the drawer as inert (unfocusable + hidden from AT).
   * We target #MainContent and footer sections — NOT the header section
   * (which contains the drawer itself).
   */
  function setInert(add) {
    var targets = [
      document.getElementById('MainContent'),
      document.querySelector('.shopify-section-group-footer-group'),
      document.querySelector('[id*="footer"].shopify-section')
    ];
    targets.forEach(function(el) {
      if (!el) return;
      if (add) {
        el.setAttribute('inert', '');
        el.setAttribute('aria-hidden', 'true');
      } else {
        el.removeAttribute('inert');
        el.removeAttribute('aria-hidden');
      }
    });
  }

  function onDrawerOpen() {
    if (isTrapping) return;
    isTrapping = true;

    setInert(true);
    document.addEventListener('keydown', onKeyDown);

    // Focus the close button after a brief delay (drawer animation)
    var closeBtn = drawer.querySelector('.js-drawer-close');
    if (closeBtn) {
      setTimeout(function() { closeBtn.focus(); }, 150);
    }
  }

  function onDrawerClose() {
    if (!isTrapping) return;
    isTrapping = false;

    setInert(false);
    document.removeEventListener('keydown', onKeyDown);

    // Return focus to the hamburger menu button
    if (menuButton) {
      setTimeout(function() { menuButton.focus(); }, 50);
    }
  }

  // Watch for class changes on the drawer element
  var observer = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].attributeName === 'class') {
        if (drawer.classList.contains('drawer--is-open')) {
          onDrawerOpen();
        } else {
          onDrawerClose();
        }
        break;
      }
    }
  });

  observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
})();
